var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"main-area"}},[_c('div',{staticClass:"container",staticStyle:{"padding-top":"45px"}},[_c('bb-reservation-main')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }